export default __webpack_public_path__ + "static/media/275.70c3a6e1.jpg";